export default () => {
  const forms = document.querySelectorAll<HTMLFormElement>(".js-form-delete");
  forms.forEach(form => {
    form.addEventListener("submit", e => {
      e.preventDefault();
      const confirmation = confirm("Are you sure you want to delete this?");
      if (confirmation) form.submit();
    });
  });
};
